import { Link, sidebarConfig } from '@backstage/core-components';
import { makeStyles } from '@material-ui/core';

const useSidebarLogoStyles = makeStyles({
  root: {
    width: sidebarConfig.drawerWidthClosed,
    height: 3 * sidebarConfig.logoHeight,
    display: 'flex',
    flexFlow: 'row nowrap',
    alignItems: 'center',
    marginBottom: -14,
  },
  link: {
    width: sidebarConfig.drawerWidthClosed,
    marginLeft: 24,
    display: 'flex',
    alignItems: 'center',
  },
  logo: {
    height: 40,
    width: 'auto',
  },
});

export const SidebarLogo = () => {
  const classes = useSidebarLogoStyles();

  return (
    <div className={classes.root}>
      <Link to="/" underline="none" className={classes.link} aria-label="Home">
        <img
          src="/datasphere-logo.png"
          alt="Datasphere Portal Logo"
          className={classes.logo}
        />
      </Link>
    </div>
  );
};
